export const ADMIN_SHOW_FACEBOOK_ONLY = ['phantila.ideaslabs', 'chetsuda.ideaslabs']

export const BYPASS_ROLE_SUPERADMIN = [
  'RS12191',
  'AN12339',
  'PR06001',
  'PRO6003',
  'CSR6062',
  'CSR6060',
  'CLA3036'
]



// WEBPACK FOOTER //
// ./src/constants/cimb_wealth.js